import { unsafeCSS, html, nothing } from "lit";
import { property, query, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { I18nController } from "../../utilities/i18n.js";
import { formatDate as formatDate$1 } from "../../utilities/date.js";
import { LeafElement } from "../leaf-element.js";
import { g as getDefaultExportFromCjs } from "../../_commonjsHelpers-LQfde5yM.js";
import "../input/input.js";
import "../label/label.js";
import "../button/button.js";
import "../icon/icon.js";
import "../validation-message/validation-message.js";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
      return test2[n];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
const assign = /* @__PURE__ */ getDefaultExportFromCjs(objectAssign);
(function(ElementProto) {
  if (typeof ElementProto.matches !== "function") {
    ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
      var element = this;
      var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
      var index = 0;
      while (elements[index] && elements[index] !== element) {
        ++index;
      }
      return Boolean(elements[index]);
    };
  }
  if (typeof ElementProto.closest !== "function") {
    ElementProto.closest = function closest(selector) {
      var element = this;
      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
      }
      return null;
    };
  }
})(window.Element.prototype);
function delegate(selector, fn) {
  return (event) => {
    const target = event.target.closest(selector);
    if (target) {
      return fn.call(target, event);
    }
  };
}
function compose(functions) {
  return function(e) {
    return functions.some((fn) => {
      return fn.call(this, e) === false;
    });
  };
}
const SPLAT = "*";
function delegateAll(selectors) {
  const keys = Object.keys(selectors);
  if (keys.length === 1 && keys[0] === SPLAT) {
    return selectors[SPLAT];
  }
  const delegates = keys.reduce(function(memo, selector) {
    memo.push(delegate(selector, selectors[selector]));
    return memo;
  }, []);
  return compose(delegates);
}
const DELEGATE_PATTERN = /^(.+):delegate\((.+)\)$/;
const SPACE = " ";
const getListeners = (type, handler) => {
  const match = type.match(DELEGATE_PATTERN);
  let selector;
  if (match) {
    type = match[1];
    selector = match[2];
  }
  let options;
  if (typeof handler === "object") {
    options = {
      capture: popKey(handler, "capture"),
      passive: popKey(handler, "passive")
    };
  }
  const listener = {
    selector,
    options,
    delegate: typeof handler === "object" ? delegateAll(handler) : selector ? delegate(selector, handler) : handler
  };
  if (type.indexOf(SPACE) > -1) {
    return type.split(SPACE).map((_type) => {
      return assign({ type: _type }, listener);
    });
  } else {
    listener.type = type;
    return [listener];
  }
};
const popKey = (obj, key) => {
  const value = obj[key];
  delete obj[key];
  return value;
};
function behavior(events, props) {
  const listeners = Object.keys(events).reduce((memo, type) => {
    const listeners2 = getListeners(type, events[type]);
    return memo.concat(listeners2);
  }, []);
  return assign(
    {
      add: (element) => {
        for (const listener of listeners) {
          element.addEventListener(listener.type, listener.delegate, listener.options);
        }
      },
      remove: (element) => {
        for (const listener of listeners) {
          element.removeEventListener(listener.type, listener.delegate, listener.options);
        }
      }
    },
    props
  );
}
var keyboardeventKeyPolyfill = { exports: {} };
(function(module, exports) {
  (function() {
    var keyboardeventKeyPolyfill2 = {
      polyfill,
      keys: {
        3: "Cancel",
        6: "Help",
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        28: "Convert",
        29: "NonConvert",
        30: "Accept",
        31: "ModeChange",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        41: "Select",
        42: "Print",
        43: "Execute",
        44: "PrintScreen",
        45: "Insert",
        46: "Delete",
        48: ["0", ")"],
        49: ["1", "!"],
        50: ["2", "@"],
        51: ["3", "#"],
        52: ["4", "$"],
        53: ["5", "%"],
        54: ["6", "^"],
        55: ["7", "&"],
        56: ["8", "*"],
        57: ["9", "("],
        91: "OS",
        93: "ContextMenu",
        144: "NumLock",
        145: "ScrollLock",
        181: "VolumeMute",
        182: "VolumeDown",
        183: "VolumeUp",
        186: [";", ":"],
        187: ["=", "+"],
        188: [",", "<"],
        189: ["-", "_"],
        190: [".", ">"],
        191: ["/", "?"],
        192: ["`", "~"],
        219: ["[", "{"],
        220: ["\\", "|"],
        221: ["]", "}"],
        222: ["'", '"'],
        224: "Meta",
        225: "AltGraph",
        246: "Attn",
        247: "CrSel",
        248: "ExSel",
        249: "EraseEof",
        250: "Play",
        251: "ZoomOut"
      }
    };
    var i;
    for (i = 1; i < 25; i++) {
      keyboardeventKeyPolyfill2.keys[111 + i] = "F" + i;
    }
    var letter = "";
    for (i = 65; i < 91; i++) {
      letter = String.fromCharCode(i);
      keyboardeventKeyPolyfill2.keys[i] = [letter.toLowerCase(), letter.toUpperCase()];
    }
    function polyfill() {
      if (!("KeyboardEvent" in window) || "key" in KeyboardEvent.prototype) {
        return false;
      }
      var proto = {
        get: function(x) {
          var key = keyboardeventKeyPolyfill2.keys[this.which || this.keyCode];
          if (Array.isArray(key)) {
            key = key[+this.shiftKey];
          }
          return key;
        }
      };
      Object.defineProperty(KeyboardEvent.prototype, "key", proto);
      return proto;
    }
    {
      module.exports = keyboardeventKeyPolyfill2;
    }
  })();
})(keyboardeventKeyPolyfill);
const isElement = (value) => value && typeof value === "object" && value.nodeType === 1;
const select = (selector, context) => {
  if (typeof selector !== "string") {
    return [];
  }
  if (!context || !isElement(context)) {
    context = window.document;
  }
  const selection = context.querySelectorAll(selector);
  return Array.prototype.slice.call(selection);
};
const sequence = (...seq) => function callHooks(target = document.body) {
  seq.forEach((method) => {
    if (typeof this[method] === "function") {
      this[method].call(this, target);
    }
  });
};
const datepickerBehavior = (events, props) => behavior(
  events,
  Object.assign(
    {
      on: sequence("init", "add"),
      off: sequence("teardown", "remove")
    },
    props
  )
);
const CLICK = "click";
const PREFIX = "usa";
const DATE_PICKER_CLASS = `${PREFIX}-date-picker`;
const DATE_PICKER_WRAPPER_CLASS = `${DATE_PICKER_CLASS}__wrapper`;
const DATE_PICKER_INITIALIZED_CLASS = `${DATE_PICKER_CLASS}--initialized`;
const DATE_PICKER_ACTIVE_CLASS = `${DATE_PICKER_CLASS}--active`;
const DATE_PICKER_INTERNAL_INPUT_CLASS = `${DATE_PICKER_CLASS}__internal-input`;
const DATE_PICKER_EXTERNAL_INPUT_CLASS = `${DATE_PICKER_CLASS}__external-input`;
const DATE_PICKER_BUTTON_CLASS = `${DATE_PICKER_CLASS}__button`;
const DATE_PICKER_CALENDAR_CLASS = `${DATE_PICKER_CLASS}__calendar`;
const DATE_PICKER_STATUS_CLASS = `${DATE_PICKER_CLASS}__status`;
const CALENDAR_DATE_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__date`;
const CALENDAR_DATE_FOCUSED_CLASS = `${CALENDAR_DATE_CLASS}--focused`;
const CALENDAR_DATE_SELECTED_CLASS = `${CALENDAR_DATE_CLASS}--selected`;
const CALENDAR_DATE_PREVIOUS_MONTH_CLASS = `${CALENDAR_DATE_CLASS}--previous-month`;
const CALENDAR_DATE_CURRENT_MONTH_CLASS = `${CALENDAR_DATE_CLASS}--current-month`;
const CALENDAR_DATE_NEXT_MONTH_CLASS = `${CALENDAR_DATE_CLASS}--next-month`;
const CALENDAR_DATE_RANGE_DATE_CLASS = `${CALENDAR_DATE_CLASS}--range-date`;
const CALENDAR_DATE_TODAY_CLASS = `${CALENDAR_DATE_CLASS}--today`;
const CALENDAR_DATE_RANGE_DATE_START_CLASS = `${CALENDAR_DATE_CLASS}--range-date-start`;
const CALENDAR_DATE_RANGE_DATE_END_CLASS = `${CALENDAR_DATE_CLASS}--range-date-end`;
const CALENDAR_DATE_WITHIN_RANGE_CLASS = `${CALENDAR_DATE_CLASS}--within-range`;
const CALENDAR_PREVIOUS_YEAR_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__previous-year`;
const CALENDAR_PREVIOUS_MONTH_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__previous-month`;
const CALENDAR_NEXT_YEAR_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__next-year`;
const CALENDAR_NEXT_MONTH_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__next-month`;
const CALENDAR_MONTH_SELECTION_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__month-selection`;
const CALENDAR_YEAR_SELECTION_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__year-selection`;
const CALENDAR_MONTH_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__month`;
const CALENDAR_MONTH_FOCUSED_CLASS = `${CALENDAR_MONTH_CLASS}--focused`;
const CALENDAR_MONTH_SELECTED_CLASS = `${CALENDAR_MONTH_CLASS}--selected`;
const CALENDAR_YEAR_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__year`;
const CALENDAR_YEAR_FOCUSED_CLASS = `${CALENDAR_YEAR_CLASS}--focused`;
const CALENDAR_YEAR_SELECTED_CLASS = `${CALENDAR_YEAR_CLASS}--selected`;
const CALENDAR_PREVIOUS_YEAR_CHUNK_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__previous-year-chunk`;
const CALENDAR_NEXT_YEAR_CHUNK_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__next-year-chunk`;
const CALENDAR_DATE_PICKER_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__date-picker`;
const CALENDAR_MONTH_PICKER_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__month-picker`;
const CALENDAR_YEAR_PICKER_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__year-picker`;
const CALENDAR_TABLE_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__table`;
const CALENDAR_ROW_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__row`;
const CALENDAR_CELL_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__cell`;
const CALENDAR_CELL_CENTER_ITEMS_CLASS = `${CALENDAR_CELL_CLASS}--center-items`;
const CALENDAR_MONTH_LABEL_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__month-label`;
const CALENDAR_DAY_OF_WEEK_CLASS = `${DATE_PICKER_CALENDAR_CLASS}__day-of-week`;
const DATE_PICKER = `.${DATE_PICKER_CLASS}`;
const DATE_PICKER_BUTTON = `.${DATE_PICKER_BUTTON_CLASS}`;
const DATE_PICKER_INTERNAL_INPUT = `.${DATE_PICKER_INTERNAL_INPUT_CLASS}`;
const DATE_PICKER_EXTERNAL_INPUT = `.${DATE_PICKER_EXTERNAL_INPUT_CLASS}`;
const DATE_PICKER_CALENDAR = `.${DATE_PICKER_CALENDAR_CLASS}`;
const DATE_PICKER_STATUS = `.${DATE_PICKER_STATUS_CLASS}`;
const CALENDAR_DATE = `.${CALENDAR_DATE_CLASS}`;
const CALENDAR_DATE_FOCUSED = `.${CALENDAR_DATE_FOCUSED_CLASS}`;
const CALENDAR_PREVIOUS_YEAR = `.${CALENDAR_PREVIOUS_YEAR_CLASS}`;
const CALENDAR_PREVIOUS_MONTH = `.${CALENDAR_PREVIOUS_MONTH_CLASS}`;
const CALENDAR_NEXT_YEAR = `.${CALENDAR_NEXT_YEAR_CLASS}`;
const CALENDAR_NEXT_MONTH = `.${CALENDAR_NEXT_MONTH_CLASS}`;
const CALENDAR_YEAR_SELECTION = `.${CALENDAR_YEAR_SELECTION_CLASS}`;
const CALENDAR_MONTH_SELECTION = `.${CALENDAR_MONTH_SELECTION_CLASS}`;
const CALENDAR_MONTH = `.${CALENDAR_MONTH_CLASS}`;
const CALENDAR_YEAR = `.${CALENDAR_YEAR_CLASS}`;
const CALENDAR_PREVIOUS_YEAR_CHUNK = `.${CALENDAR_PREVIOUS_YEAR_CHUNK_CLASS}`;
const CALENDAR_NEXT_YEAR_CHUNK = `.${CALENDAR_NEXT_YEAR_CHUNK_CLASS}`;
const CALENDAR_DATE_PICKER = `.${CALENDAR_DATE_PICKER_CLASS}`;
const CALENDAR_MONTH_PICKER = `.${CALENDAR_MONTH_PICKER_CLASS}`;
const CALENDAR_YEAR_PICKER = `.${CALENDAR_YEAR_PICKER_CLASS}`;
const CALENDAR_MONTH_FOCUSED = `.${CALENDAR_MONTH_FOCUSED_CLASS}`;
const CALENDAR_YEAR_FOCUSED = `.${CALENDAR_YEAR_FOCUSED_CLASS}`;
let MONTH_LABELS = [];
const setMonthLabels = (el) => MONTH_LABELS = el;
let MONTH_LABELS_SHORT = [];
const setShortMonthLabels = (el) => MONTH_LABELS_SHORT = el;
let DAY_OF_WEEK_LABELS = [];
const setDayOfWeekLabels = (el) => DAY_OF_WEEK_LABELS = el;
let DAY_OF_WEEK_LABELS_SHORT = [];
const setShortDayOfWeekLabels = (el) => DAY_OF_WEEK_LABELS_SHORT = el;
let INSTRUCTIONS = [];
const setInstructions = (el) => INSTRUCTIONS = el;
let CALENDAR_NAVIGATIONS = [];
const setCalendarNavigations = (el) => CALENDAR_NAVIGATIONS = el;
let SELECTIONS = [];
const setSelections = (el) => SELECTIONS = el;
const ENTER_KEYCODE = 13;
const YEAR_CHUNK = 12;
const DEFAULT_MIN_DATE = "0000-01-01";
const DEFAULT_EXTERNAL_DATE_FORMAT = "MM/DD/YYYY";
const INTERNAL_DATE_FORMAT = "YYYY-MM-DD";
let DATEPICKER_DATE_FORMAT = "";
const setDateFormat = (el) => DATEPICKER_DATE_FORMAT = el;
const NOT_DISABLED_SELECTOR = ":not([disabled])";
const processFocusableSelectors = (...selectors) => selectors.map((query2) => query2 + NOT_DISABLED_SELECTOR).join(", ");
const DATE_PICKER_FOCUSABLE = processFocusableSelectors(
  CALENDAR_PREVIOUS_YEAR,
  CALENDAR_PREVIOUS_MONTH,
  CALENDAR_YEAR_SELECTION,
  CALENDAR_MONTH_SELECTION,
  CALENDAR_NEXT_YEAR,
  CALENDAR_NEXT_MONTH,
  CALENDAR_DATE_FOCUSED
);
const MONTH_PICKER_FOCUSABLE = processFocusableSelectors(CALENDAR_MONTH_FOCUSED);
const YEAR_PICKER_FOCUSABLE = processFocusableSelectors(
  CALENDAR_PREVIOUS_YEAR_CHUNK,
  CALENDAR_NEXT_YEAR_CHUNK,
  CALENDAR_YEAR_FOCUSED
);
const keepDateWithinMonth = (dateToCheck, month) => {
  if (month !== dateToCheck.getMonth()) {
    dateToCheck.setDate(0);
  }
  return dateToCheck;
};
const setDate = (year, month, date) => {
  const newDate = /* @__PURE__ */ new Date(0);
  newDate.setFullYear(year, month, date);
  return newDate;
};
const today = () => {
  const newDate = /* @__PURE__ */ new Date();
  const day = newDate.getDate();
  const month = newDate.getMonth();
  const year = newDate.getFullYear();
  return setDate(year, month, day);
};
const startOfMonth = (date) => {
  const newDate = /* @__PURE__ */ new Date(0);
  newDate.setFullYear(date.getFullYear(), date.getMonth(), 1);
  return newDate;
};
const lastDayOfMonth = (date) => {
  const newDate = /* @__PURE__ */ new Date(0);
  newDate.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
  return newDate;
};
const addDays = (_date, numDays) => {
  const newDate = new Date(_date.getTime());
  newDate.setDate(newDate.getDate() + numDays);
  return newDate;
};
const subDays = (_date, numDays) => addDays(_date, -numDays);
const addWeeks = (_date, numWeeks) => addDays(_date, numWeeks * 7);
const subWeeks = (_date, numWeeks) => addWeeks(_date, -numWeeks);
const startOfWeek = (_date) => {
  const dayOfWeek = _date.getDay();
  return subDays(_date, dayOfWeek);
};
const endOfWeek = (_date) => {
  const dayOfWeek = _date.getDay();
  return addDays(_date, 6 - dayOfWeek);
};
const addMonths = (_date, numMonths) => {
  const newDate = new Date(_date.getTime());
  const dateMonth = (newDate.getMonth() + 12 + numMonths) % 12;
  newDate.setMonth(newDate.getMonth() + numMonths);
  keepDateWithinMonth(newDate, dateMonth);
  return newDate;
};
const subMonths = (_date, numMonths) => addMonths(_date, -numMonths);
const addYears = (_date, numYears) => addMonths(_date, numYears * 12);
const subYears = (_date, numYears) => addYears(_date, -numYears);
const setMonth = (_date, month) => {
  const newDate = new Date(_date.getTime());
  newDate.setMonth(month);
  keepDateWithinMonth(newDate, month);
  return newDate;
};
const setYear = (_date, year) => {
  const newDate = new Date(_date.getTime());
  const month = newDate.getMonth();
  newDate.setFullYear(year);
  keepDateWithinMonth(newDate, month);
  return newDate;
};
const min = (dateA, dateB) => {
  let newDate = dateA;
  if (dateB < dateA) {
    newDate = dateB;
  }
  return new Date(newDate.getTime());
};
const max = (dateA, dateB) => {
  let newDate = dateA;
  if (dateB > dateA) {
    newDate = dateB;
  }
  return new Date(newDate.getTime());
};
const isSameYear = (dateA, dateB) => {
  return dateA && dateB && dateA.getFullYear() === dateB.getFullYear();
};
const isSameMonth = (dateA, dateB) => {
  return isSameYear(dateA, dateB) && dateA.getMonth() === dateB.getMonth();
};
const isSameDay = (dateA, dateB) => {
  return isSameMonth(dateA, dateB) && dateA.getDate() === dateB.getDate();
};
const keepDateBetweenMinAndMax = (date, minDate, maxDate) => {
  let newDate = date;
  if (date < minDate) {
    newDate = minDate;
  } else if (maxDate && date > maxDate) {
    newDate = maxDate;
  }
  return new Date(newDate.getTime());
};
const isDateWithinMinAndMax = (date, minDate, maxDate) => date >= minDate && (!maxDate || date <= maxDate);
const isDatesMonthOutsideMinOrMax = (date, minDate, maxDate) => {
  return lastDayOfMonth(date) < minDate || maxDate && startOfMonth(date) > maxDate;
};
const isDatesYearOutsideMinOrMax = (date, minDate, maxDate) => {
  return lastDayOfMonth(setMonth(date, 11)) < minDate || maxDate && startOfMonth(setMonth(date, 0)) > maxDate;
};
const parseDateString = (dateString, dateFormat = INTERNAL_DATE_FORMAT, adjustDate = false) => {
  let date;
  let month;
  let day;
  let year;
  let parsed;
  if (dateString) {
    let monthStr, dayStr, yearStr;
    if (dateFormat === DEFAULT_EXTERNAL_DATE_FORMAT) {
      [monthStr, dayStr, yearStr] = dateString.split("/");
    } else {
      [yearStr, monthStr, dayStr] = dateString.split("-");
    }
    if (yearStr) {
      parsed = parseInt(yearStr, 10);
      if (!Number.isNaN(parsed)) {
        year = parsed;
        if (adjustDate) {
          year = Math.max(0, year);
          if (yearStr.length < 3) {
            const currentYear = today().getFullYear();
            const currentYearStub = currentYear - currentYear % 10 ** yearStr.length;
            year = currentYearStub + parsed;
          }
        }
      }
    }
    if (monthStr) {
      parsed = parseInt(monthStr, 10);
      if (!Number.isNaN(parsed)) {
        month = parsed;
        if (adjustDate) {
          month = Math.max(1, month);
          month = Math.min(12, month);
        }
      }
    }
    if (month && dayStr && year != null) {
      parsed = parseInt(dayStr, 10);
      if (!Number.isNaN(parsed)) {
        day = parsed;
        if (adjustDate) {
          const lastDayOfTheMonth = setDate(year, month, 0).getDate();
          day = Math.max(1, day);
          day = Math.min(lastDayOfTheMonth, day);
        }
      }
    }
    if (month && day && year != null) {
      date = setDate(year, month - 1, day);
    }
  }
  return date;
};
const formatDate = (date, dateFormat = INTERNAL_DATE_FORMAT) => {
  const padZeros = (value, length) => {
    return `0000${value}`.slice(-length);
  };
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  if (dateFormat === DEFAULT_EXTERNAL_DATE_FORMAT) {
    return [padZeros(month, 2), padZeros(day, 2), padZeros(year, 4)].join("/");
  }
  return [padZeros(year, 4), padZeros(month, 2), padZeros(day, 2)].join("-");
};
const listToGridHtml = (htmlArray, rowSize) => {
  const grid = [];
  let row = [];
  let i = 0;
  while (i < htmlArray.length) {
    row = [];
    while (i < htmlArray.length && row.length < rowSize) {
      const isSelected = htmlArray[i].indexOf('data-date-selected="true"') > -1;
      row.push(`<td role="gridcell" aria-selected="${isSelected ? "true" : "false"}">${htmlArray[i]}</td>`);
      i += 1;
    }
    grid.push(`<tr role="row">${row.join("")}</tr>`);
  }
  return grid.join("");
};
const changeElementValue = (el, value = "", auto = true) => {
  const elementToChange = el;
  elementToChange.value = value;
  if (auto) {
    const event = new CustomEvent("change", {
      bubbles: true,
      cancelable: true,
      detail: { value }
    });
    elementToChange.dispatchEvent(event);
  }
};
const getDatePickerContext = (el) => {
  const datePickerEl = el.closest(DATE_PICKER);
  if (!datePickerEl) {
    throw new Error(`Element is missing outer ${DATE_PICKER}`);
  }
  const internalInputEl = datePickerEl.querySelector(DATE_PICKER_INTERNAL_INPUT);
  const externalInputEl = datePickerEl.querySelector(DATE_PICKER_EXTERNAL_INPUT);
  const calendarEl = datePickerEl.querySelector(DATE_PICKER_CALENDAR);
  const toggleBtnEl = datePickerEl.querySelector(DATE_PICKER_BUTTON);
  const statusEl = datePickerEl.querySelector(DATE_PICKER_STATUS);
  const firstYearChunkEl = datePickerEl.querySelector(CALENDAR_YEAR);
  const inputDate = parseDateString(externalInputEl.value, DATEPICKER_DATE_FORMAT, true);
  const selectedDate = parseDateString(internalInputEl.value);
  const calendarDate = parseDateString(calendarEl.dataset.value);
  const minDate = parseDateString(datePickerEl.dataset.minDate);
  const maxDate = parseDateString(datePickerEl.dataset.maxDate);
  const rangeDate = parseDateString(datePickerEl.dataset.rangeDate);
  const defaultDate = parseDateString(datePickerEl.dataset.defaultDate);
  if (minDate && maxDate && minDate > maxDate) {
    throw new Error("Minimum date cannot be after maximum date");
  }
  return {
    calendarDate,
    minDate,
    toggleBtnEl,
    selectedDate,
    maxDate,
    firstYearChunkEl,
    datePickerEl,
    inputDate,
    internalInputEl,
    externalInputEl,
    calendarEl,
    rangeDate,
    defaultDate,
    statusEl
  };
};
const disable = (el) => {
  const { externalInputEl, toggleBtnEl } = getDatePickerContext(el);
  toggleBtnEl.disabled = true;
  externalInputEl.disabled = true;
};
const enable = (el) => {
  const { externalInputEl, toggleBtnEl } = getDatePickerContext(el);
  toggleBtnEl.disabled = false;
  externalInputEl.disabled = false;
};
const isDateInputInvalid = (el) => {
  const { externalInputEl, minDate, maxDate } = getDatePickerContext(el);
  const dateString = externalInputEl.value;
  let isInvalid = false;
  if (dateString) {
    isInvalid = true;
    const dateStringParts = dateString.split("/");
    const [month, day, year] = dateStringParts.map((str) => {
      let value;
      const parsed = parseInt(str, 10);
      if (!Number.isNaN(parsed))
        value = parsed;
      return value;
    });
    if (month && day && year != null) {
      const checkDate = setDate(year, month - 1, day);
      if (checkDate.getMonth() === month - 1 && checkDate.getDate() === day && checkDate.getFullYear() === year && dateStringParts[2].length === 4 && isDateWithinMinAndMax(checkDate, minDate, maxDate)) {
        isInvalid = false;
      }
    }
  }
  return isInvalid;
};
const reconcileInputValues = (el) => {
  const { internalInputEl, inputDate } = getDatePickerContext(el);
  let newValue = "";
  if (inputDate && !isDateInputInvalid(el)) {
    newValue = formatDate(inputDate);
  }
  if (internalInputEl.value !== newValue) {
    changeElementValue(internalInputEl, newValue);
  }
};
const setCalendarValue = (el, dateString, auto = true) => {
  const parsedDate = parseDateString(dateString);
  if (parsedDate) {
    const formattedDate = formatDate(parsedDate, DATEPICKER_DATE_FORMAT);
    const { internalInputEl, externalInputEl } = getDatePickerContext(el);
    changeElementValue(internalInputEl, dateString, auto);
    changeElementValue(externalInputEl, formattedDate, auto);
  }
};
const enhanceDatePicker = (el) => {
  const datePickerEl = el.closest(DATE_PICKER);
  const defaultValue = datePickerEl.dataset.defaultValue;
  const internalInputEl = datePickerEl.querySelector("leaf-input");
  if (!internalInputEl) {
    throw new Error(`${DATE_PICKER} is missing inner input`);
  }
  if (internalInputEl.value) {
    internalInputEl.value = "";
  }
  const minDate = parseDateString(datePickerEl.dataset.minDate || internalInputEl.getAttribute("min"));
  datePickerEl.dataset.minDate = minDate ? formatDate(minDate) : DEFAULT_MIN_DATE;
  const maxDate = parseDateString(datePickerEl.dataset.maxDate || internalInputEl.getAttribute("max"));
  if (maxDate) {
    datePickerEl.dataset.maxDate = formatDate(maxDate);
  }
  const calendarWrapper = document.createElement("div");
  calendarWrapper.classList.add(DATE_PICKER_WRAPPER_CLASS);
  const externalInputEl = internalInputEl.cloneNode();
  const externalInputSlot = internalInputEl.querySelector('[slot="note"]');
  if (externalInputSlot) {
    externalInputEl.insertAdjacentElement("beforeend", externalInputSlot);
  }
  externalInputEl.classList.add(DATE_PICKER_EXTERNAL_INPUT_CLASS);
  externalInputEl.type = internalInputEl.getAttribute("type");
  externalInputEl.name = "";
  calendarWrapper.appendChild(externalInputEl);
  calendarWrapper.insertAdjacentHTML(
    "beforeend",
    `<span id="after" hidden></span><leaf-button class="${DATE_PICKER_BUTTON_CLASS}" variant="tertiary"><leaf-icon slot="icon-before" label="assistive tech label" set="system" name="calendar-today"></leaf-icon></leaf-button><div class="${DATE_PICKER_CALENDAR_CLASS}" role="dialog" aria-modal="true" hidden></div><div class="usa-sr-only ${DATE_PICKER_STATUS_CLASS}" role="status" aria-live="polite"></div>`
  );
  internalInputEl.classList.add("usa-sr-only", DATE_PICKER_INTERNAL_INPUT_CLASS);
  internalInputEl.id = "";
  internalInputEl.required = false;
  datePickerEl.appendChild(calendarWrapper);
  datePickerEl.classList.add(DATE_PICKER_INITIALIZED_CLASS);
  if (defaultValue) {
    setCalendarValue(datePickerEl, defaultValue);
  }
  if (internalInputEl.disabled) {
    disable(datePickerEl);
    internalInputEl.disabled = false;
  }
};
const renderCalendar = (el, _dateToDisplay) => {
  const { datePickerEl, calendarEl, statusEl, selectedDate, maxDate, minDate, rangeDate } = getDatePickerContext(el);
  const todaysDate = today();
  let dateToDisplay = _dateToDisplay || todaysDate;
  const calendarWasHidden = calendarEl.hidden;
  el.previousSibling.classList.add("open");
  const focusedDate = addDays(dateToDisplay, 0);
  const focusedMonth = dateToDisplay.getMonth();
  const focusedYear = dateToDisplay.getFullYear();
  const prevMonth = subMonths(dateToDisplay, 1);
  const nextMonth = addMonths(dateToDisplay, 1);
  const currentFormattedDate = formatDate(dateToDisplay);
  const firstOfMonth = startOfMonth(dateToDisplay);
  const prevButtonsDisabled = isSameMonth(dateToDisplay, minDate);
  const nextButtonsDisabled = isSameMonth(dateToDisplay, maxDate);
  const rangeConclusionDate = selectedDate || dateToDisplay;
  const rangeStartDate = rangeDate && min(rangeConclusionDate, rangeDate);
  const rangeEndDate = rangeDate && max(rangeConclusionDate, rangeDate);
  const withinRangeStartDate = rangeDate && addDays(rangeStartDate, 1);
  const withinRangeEndDate = rangeDate && subDays(rangeEndDate, 1);
  const monthLabel = MONTH_LABELS_SHORT[focusedMonth];
  const generateDateHtml = (dateToRender) => {
    const classes = [CALENDAR_DATE_CLASS];
    const day = dateToRender.getDate();
    const month = dateToRender.getMonth();
    const year = dateToRender.getFullYear();
    const dayOfWeek = dateToRender.getDay();
    const formattedDate = formatDate(dateToRender);
    let tabindex = "-1";
    const isDisabled = !isDateWithinMinAndMax(dateToRender, minDate, maxDate);
    const isSelected = isSameDay(dateToRender, selectedDate);
    if (isSameMonth(dateToRender, prevMonth)) {
      classes.push(CALENDAR_DATE_PREVIOUS_MONTH_CLASS);
    }
    if (isSameMonth(dateToRender, focusedDate)) {
      classes.push(CALENDAR_DATE_CURRENT_MONTH_CLASS);
    }
    if (isSameMonth(dateToRender, nextMonth)) {
      classes.push(CALENDAR_DATE_NEXT_MONTH_CLASS);
    }
    if (isSelected) {
      classes.push(CALENDAR_DATE_SELECTED_CLASS);
    }
    if (isSameDay(dateToRender, todaysDate)) {
      classes.push(CALENDAR_DATE_TODAY_CLASS);
    }
    if (rangeDate) {
      if (isSameDay(dateToRender, rangeDate)) {
        classes.push(CALENDAR_DATE_RANGE_DATE_CLASS);
      }
      if (isSameDay(dateToRender, rangeStartDate)) {
        classes.push(CALENDAR_DATE_RANGE_DATE_START_CLASS);
      }
      if (isSameDay(dateToRender, rangeEndDate)) {
        classes.push(CALENDAR_DATE_RANGE_DATE_END_CLASS);
      }
      if (isDateWithinMinAndMax(dateToRender, withinRangeStartDate, withinRangeEndDate)) {
        classes.push(CALENDAR_DATE_WITHIN_RANGE_CLASS);
      }
    }
    if (isSameDay(dateToRender, focusedDate)) {
      tabindex = "0";
      classes.push(CALENDAR_DATE_FOCUSED_CLASS);
    }
    const monthStr = MONTH_LABELS[month];
    const dayStr = DAY_OF_WEEK_LABELS[dayOfWeek];
    return `<button
      type="button"
      tabindex="${tabindex}"
      class="${classes.join(" ")}"
      data-day="${day}"
      data-month="${month + 1}"
      data-year="${year}"
      data-value="${formattedDate}"
      aria-label="${day} ${monthStr} ${year} ${dayStr}"
      data-date-selected="${isSelected ? "true" : "false"}"
      ${isDisabled ? `disabled="disabled"` : ""}
    >${day}</button>`;
  };
  dateToDisplay = startOfWeek(firstOfMonth);
  const days = [];
  while (days.length < 28 || dateToDisplay.getMonth() === focusedMonth || days.length % 7 !== 0) {
    days.push(generateDateHtml(dateToDisplay));
    dateToDisplay = addDays(dateToDisplay, 1);
  }
  const datesHtml = listToGridHtml(days, 7);
  const newCalendar = calendarEl.cloneNode();
  const externalInputElHeight = datePickerEl.querySelector(`.${DATE_PICKER_WRAPPER_CLASS} .${DATE_PICKER_EXTERNAL_INPUT_CLASS} input`).offsetHeight + 8;
  newCalendar.dataset.value = currentFormattedDate;
  newCalendar.style.top = `${externalInputElHeight}px`;
  newCalendar.style.zIndex = 200;
  newCalendar.hidden = false;
  newCalendar.innerHTML = `<div tabindex="-1" class="${CALENDAR_DATE_PICKER_CLASS}">
      <div class="${CALENDAR_ROW_CLASS}">
        <div class="${CALENDAR_CELL_CLASS} ${CALENDAR_CELL_CENTER_ITEMS_CLASS}">
          <button
            type="button"
            class="${CALENDAR_PREVIOUS_YEAR_CLASS}"
            aria-label="${CALENDAR_NAVIGATIONS[0]}"
            ${prevButtonsDisabled ? `disabled="disabled"` : ""}
          ><leaf-icon slot="icon" set="system" name="keyboard-double-arrow-left" size="large"></leaf-icon></button>
        </div>
        <div class="${CALENDAR_CELL_CLASS} ${CALENDAR_CELL_CENTER_ITEMS_CLASS}">
          <button
            type="button"
            class="${CALENDAR_PREVIOUS_MONTH_CLASS}"
            aria-label="${CALENDAR_NAVIGATIONS[1]}"
            ${prevButtonsDisabled ? `disabled="disabled"` : ""}
          ><leaf-icon slot="icon" set="system" name="keyboard-arrow-left" size="large"></leaf-icon></button>
        </div>
        <div class="${CALENDAR_CELL_CLASS} ${CALENDAR_MONTH_LABEL_CLASS}">
          <button
            type="button"
            class="${CALENDAR_MONTH_SELECTION_CLASS}" aria-label="${monthLabel}. ${CALENDAR_NAVIGATIONS[2]}"
          >${monthLabel}</button>
          <button
            type="button"
            class="${CALENDAR_YEAR_SELECTION_CLASS}" aria-label="${focusedYear}. ${CALENDAR_NAVIGATIONS[3]}"
          >${focusedYear}</button>
        </div>
        <div class="${CALENDAR_CELL_CLASS} ${CALENDAR_CELL_CENTER_ITEMS_CLASS}">
          <button
            type="button"
            class="${CALENDAR_NEXT_MONTH_CLASS}"
            aria-label="${CALENDAR_NAVIGATIONS[4]}"
            ${nextButtonsDisabled ? `disabled="disabled"` : ""}
          ><leaf-icon slot="icon" set="system" name="keyboard-arrow-right" size="large"></leaf-icon></button>
        </div>
        <div class="${CALENDAR_CELL_CLASS} ${CALENDAR_CELL_CENTER_ITEMS_CLASS}">
          <button
            type="button"
            class="${CALENDAR_NEXT_YEAR_CLASS}"
            aria-label="${CALENDAR_NAVIGATIONS[5]}"
            ${nextButtonsDisabled ? `disabled="disabled"` : ""}
          ><leaf-icon slot="icon" set="system" name="keyboard-double-arrow-right" size="large"></leaf-icon></button>
        </div>
      </div>
      <table class="${CALENDAR_TABLE_CLASS}" role="table">
        <thead>
          <tr>
            <th class="${CALENDAR_DAY_OF_WEEK_CLASS}" scope="col" aria-label="${DAY_OF_WEEK_LABELS[0]}">${DAY_OF_WEEK_LABELS_SHORT[0]}</th>
            <th class="${CALENDAR_DAY_OF_WEEK_CLASS}" scope="col" aria-label="${DAY_OF_WEEK_LABELS[1]}">${DAY_OF_WEEK_LABELS_SHORT[1]}</th>
            <th class="${CALENDAR_DAY_OF_WEEK_CLASS}" scope="col" aria-label="${DAY_OF_WEEK_LABELS[2]}">${DAY_OF_WEEK_LABELS_SHORT[2]}</th>
            <th class="${CALENDAR_DAY_OF_WEEK_CLASS}" scope="col" aria-label="${DAY_OF_WEEK_LABELS[3]}">${DAY_OF_WEEK_LABELS_SHORT[3]}</th>
            <th class="${CALENDAR_DAY_OF_WEEK_CLASS}" scope="col" aria-label="${DAY_OF_WEEK_LABELS[4]}">${DAY_OF_WEEK_LABELS_SHORT[4]}</th>
            <th class="${CALENDAR_DAY_OF_WEEK_CLASS}" scope="col" aria-label="${DAY_OF_WEEK_LABELS[5]}">${DAY_OF_WEEK_LABELS_SHORT[5]}</th>
            <th class="${CALENDAR_DAY_OF_WEEK_CLASS}" scope="col" aria-label="${DAY_OF_WEEK_LABELS[6]}">${DAY_OF_WEEK_LABELS_SHORT[6]}</th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          ${datesHtml}
        </tbody>
      </table>
    </div>`;
  calendarEl.parentNode.replaceChild(newCalendar, calendarEl);
  datePickerEl.classList.add(DATE_PICKER_ACTIVE_CLASS);
  const statuses = [];
  if (isSameDay(selectedDate, focusedDate)) {
    statuses.push(`${CALENDAR_NAVIGATIONS[6]}`);
  }
  if (calendarWasHidden) {
    statuses.push(
      `${INSTRUCTIONS[0]}`,
      `${INSTRUCTIONS[1]}`,
      `${INSTRUCTIONS[2]}`,
      `${INSTRUCTIONS[3]}`,
      `${INSTRUCTIONS[4]}`
    );
    statusEl.textContent = "";
  } else {
    statuses.push(`${monthLabel} ${focusedYear}`);
  }
  statusEl.textContent = statuses.join(". ");
  return newCalendar;
};
const displayPreviousYear = (_buttonEl) => {
  if (_buttonEl.disabled)
    return;
  const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(_buttonEl);
  let date = subYears(calendarDate, 1);
  date = keepDateBetweenMinAndMax(date, minDate, maxDate);
  const newCalendar = renderCalendar(calendarEl, date);
  let nextToFocus = newCalendar.querySelector(CALENDAR_PREVIOUS_YEAR);
  if (nextToFocus.disabled) {
    nextToFocus = newCalendar.querySelector(CALENDAR_DATE_PICKER);
  }
  nextToFocus.focus();
};
const displayPreviousMonth = (_buttonEl) => {
  if (_buttonEl.disabled)
    return;
  const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(_buttonEl);
  let date = subMonths(calendarDate, 1);
  date = keepDateBetweenMinAndMax(date, minDate, maxDate);
  const newCalendar = renderCalendar(calendarEl, date);
  let nextToFocus = newCalendar.querySelector(CALENDAR_PREVIOUS_MONTH);
  if (nextToFocus.disabled) {
    nextToFocus = newCalendar.querySelector(CALENDAR_DATE_PICKER);
  }
  nextToFocus.focus();
};
const displayNextMonth = (_buttonEl) => {
  if (_buttonEl.disabled)
    return;
  const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(_buttonEl);
  let date = addMonths(calendarDate, 1);
  date = keepDateBetweenMinAndMax(date, minDate, maxDate);
  const newCalendar = renderCalendar(calendarEl, date);
  let nextToFocus = newCalendar.querySelector(CALENDAR_NEXT_MONTH);
  if (nextToFocus.disabled) {
    nextToFocus = newCalendar.querySelector(CALENDAR_DATE_PICKER);
  }
  nextToFocus.focus();
};
const displayNextYear = (_buttonEl) => {
  if (_buttonEl.disabled)
    return;
  const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(_buttonEl);
  let date = addYears(calendarDate, 1);
  date = keepDateBetweenMinAndMax(date, minDate, maxDate);
  const newCalendar = renderCalendar(calendarEl, date);
  let nextToFocus = newCalendar.querySelector(CALENDAR_NEXT_YEAR);
  if (nextToFocus.disabled) {
    nextToFocus = newCalendar.querySelector(CALENDAR_DATE_PICKER);
  }
  nextToFocus.focus();
};
const hideCalendar = (el) => {
  const { datePickerEl, calendarEl, statusEl } = getDatePickerContext(el);
  datePickerEl.classList.remove(DATE_PICKER_ACTIVE_CLASS);
  calendarEl.hidden = true;
  calendarEl.previousSibling.classList.remove("open");
  statusEl.textContent = "";
};
const selectDate = (calendarDateEl) => {
  if (calendarDateEl.disabled)
    return;
  const { datePickerEl, externalInputEl } = getDatePickerContext(calendarDateEl);
  setCalendarValue(calendarDateEl, calendarDateEl.dataset.value);
  hideCalendar(datePickerEl);
  externalInputEl.focus();
};
const toggleCalendar = (el) => {
  if (el.disabled)
    return;
  const { calendarEl, inputDate, minDate, maxDate, defaultDate } = getDatePickerContext(el);
  if (calendarEl.hidden) {
    const dateToDisplay = keepDateBetweenMinAndMax(inputDate || defaultDate || today(), minDate, maxDate);
    const newCalendar = renderCalendar(calendarEl, dateToDisplay);
    newCalendar.querySelector(CALENDAR_DATE_FOCUSED).focus();
    newCalendar.querySelector(CALENDAR_DATE_FOCUSED).parentNode.setAttribute("aria-selected", "true");
  } else {
    hideCalendar(el);
  }
};
const updateCalendarIfVisible = (el) => {
  const { calendarEl, inputDate, minDate, maxDate } = getDatePickerContext(el);
  const calendarShown = !calendarEl.hidden;
  if (calendarShown && inputDate) {
    const dateToDisplay = keepDateBetweenMinAndMax(inputDate, minDate, maxDate);
    renderCalendar(calendarEl, dateToDisplay);
  }
};
const displayMonthSelection = (el, monthToDisplay) => {
  const { calendarEl, statusEl, calendarDate, minDate, maxDate } = getDatePickerContext(el);
  const selectedMonth = calendarDate.getMonth();
  const focusedMonth = monthToDisplay == null ? selectedMonth : monthToDisplay;
  const months = MONTH_LABELS.map((month, index) => {
    const monthToCheck = setMonth(calendarDate, index);
    const isDisabled = isDatesMonthOutsideMinOrMax(monthToCheck, minDate, maxDate);
    let tabindex = "-1";
    const classes = [CALENDAR_MONTH_CLASS];
    const isSelected = index === selectedMonth;
    if (index === focusedMonth) {
      tabindex = "0";
      classes.push(CALENDAR_MONTH_FOCUSED_CLASS);
    }
    if (isSelected) {
      classes.push(CALENDAR_MONTH_SELECTED_CLASS);
    }
    return `<button
        type="button"
        tabindex="${tabindex}"
        class="${classes.join(" ")}"
        data-value="${index}"
        data-label="${month}"
        data-date-selected="${isSelected ? "true" : "false"}"
        ${isDisabled ? `disabled="disabled"` : ""}
      >${month}</button>`;
  });
  const monthsHtml = `<div tabindex="-1" class="${CALENDAR_MONTH_PICKER_CLASS}">
    <table class="${CALENDAR_TABLE_CLASS}" role="table">
      <tbody role="rowgroup">
        ${listToGridHtml(months, 2)}
      </tbody>
    </table>
  </div>`;
  const newCalendar = calendarEl.cloneNode();
  newCalendar.innerHTML = monthsHtml;
  calendarEl.parentNode.replaceChild(newCalendar, calendarEl);
  statusEl.textContent = `${SELECTIONS[5]}.`;
  return newCalendar;
};
const selectMonth = (monthEl) => {
  if (monthEl.disabled)
    return;
  const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(monthEl);
  const selectedMonth = parseInt(monthEl.dataset.value, 10);
  let date = setMonth(calendarDate, selectedMonth);
  date = keepDateBetweenMinAndMax(date, minDate, maxDate);
  const newCalendar = renderCalendar(calendarEl, date);
  newCalendar.querySelector(CALENDAR_DATE_FOCUSED).focus();
};
const displayYearSelection = (el, yearToDisplay) => {
  const { calendarEl, statusEl, calendarDate, minDate, maxDate } = getDatePickerContext(el);
  const selectedYear = calendarDate.getFullYear();
  const focusedYear = yearToDisplay == null ? selectedYear : yearToDisplay;
  let yearToChunk = focusedYear;
  yearToChunk -= yearToChunk % YEAR_CHUNK;
  yearToChunk = Math.max(0, yearToChunk);
  const prevYearChunkDisabled = isDatesYearOutsideMinOrMax(setYear(calendarDate, yearToChunk - 1), minDate, maxDate);
  const nextYearChunkDisabled = isDatesYearOutsideMinOrMax(
    setYear(calendarDate, yearToChunk + YEAR_CHUNK),
    minDate,
    maxDate
  );
  const years = [];
  let yearIndex = yearToChunk;
  while (years.length < YEAR_CHUNK) {
    const isDisabled = isDatesYearOutsideMinOrMax(setYear(calendarDate, yearIndex), minDate, maxDate);
    let tabindex = "-1";
    const classes = [CALENDAR_YEAR_CLASS];
    const isSelected = yearIndex === selectedYear;
    if (yearIndex === focusedYear) {
      tabindex = "0";
      classes.push(CALENDAR_YEAR_FOCUSED_CLASS);
    }
    if (isSelected) {
      classes.push(CALENDAR_YEAR_SELECTED_CLASS);
    }
    years.push(
      `<button
        type="button"
        tabindex="${tabindex}"
        class="${classes.join(" ")}"
        data-value="${yearIndex}"
        data-date-selected="${isSelected ? "true" : "false"}"
        ${isDisabled ? `disabled="disabled"` : ""}
      >${yearIndex}</button>`
    );
    yearIndex += 1;
  }
  const yearsHtml = listToGridHtml(years, 3);
  const newCalendar = calendarEl.cloneNode();
  newCalendar.innerHTML = `<div tabindex="-1" class="${CALENDAR_YEAR_PICKER_CLASS}">
    <table class="${CALENDAR_TABLE_CLASS}" role="table">
        <tbody>
          <tr>
            <td>
              <button
                type="button"
                class="${CALENDAR_PREVIOUS_YEAR_CHUNK_CLASS}"
                aria-label="${SELECTIONS[0]} ${YEAR_CHUNK} ${SELECTIONS[2]}"
                ${prevYearChunkDisabled ? `disabled="disabled"` : ""}
              ><leaf-icon slot="icon" set="system" name="keyboard-arrow-left" size="large"></leaf-icon></button>
            </td>
            <td colspan="4" style="padding-right: 8px; padding-left: 8px;">
              <table class="${CALENDAR_TABLE_CLASS}" role="table">
                <tbody role="rowgroup">
                  ${yearsHtml}
                </tbody>
              </table>
            </td>
            <td>
              <button
                type="button"
                class="${CALENDAR_NEXT_YEAR_CHUNK_CLASS}"
                aria-label="${SELECTIONS[1]} ${YEAR_CHUNK} ${SELECTIONS[2]}"
                ${nextYearChunkDisabled ? `disabled="disabled"` : ""}
              ><leaf-icon slot="icon" set="system" name="keyboard-arrow-right" size="large"></leaf-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>`;
  calendarEl.parentNode.replaceChild(newCalendar, calendarEl);
  statusEl.textContent = `${SELECTIONS[3]} ${yearToChunk} ${SELECTIONS[6]} ${yearToChunk + YEAR_CHUNK - 1}. ${SELECTIONS[4]}.`;
  return newCalendar;
};
const displayPreviousYearChunk = (el) => {
  if (el.disabled)
    return;
  const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(el);
  const yearEl = calendarEl.querySelector(CALENDAR_YEAR_FOCUSED);
  const selectedYear = parseInt(yearEl.textContent, 10);
  let adjustedYear = selectedYear - YEAR_CHUNK;
  adjustedYear = Math.max(0, adjustedYear);
  const date = setYear(calendarDate, adjustedYear);
  const cappedDate = keepDateBetweenMinAndMax(date, minDate, maxDate);
  const newCalendar = displayYearSelection(calendarEl, cappedDate.getFullYear());
  let nextToFocus = newCalendar.querySelector(CALENDAR_PREVIOUS_YEAR_CHUNK);
  if (nextToFocus.disabled) {
    nextToFocus = newCalendar.querySelector(CALENDAR_YEAR_PICKER);
  }
  nextToFocus.focus();
};
const displayNextYearChunk = (el) => {
  if (el.disabled)
    return;
  const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(el);
  const yearEl = calendarEl.querySelector(CALENDAR_YEAR_FOCUSED);
  const selectedYear = parseInt(yearEl.textContent, 10);
  let adjustedYear = selectedYear + YEAR_CHUNK;
  adjustedYear = Math.max(0, adjustedYear);
  const date = setYear(calendarDate, adjustedYear);
  const cappedDate = keepDateBetweenMinAndMax(date, minDate, maxDate);
  const newCalendar = displayYearSelection(calendarEl, cappedDate.getFullYear());
  let nextToFocus = newCalendar.querySelector(CALENDAR_NEXT_YEAR_CHUNK);
  if (nextToFocus.disabled) {
    nextToFocus = newCalendar.querySelector(CALENDAR_YEAR_PICKER);
  }
  nextToFocus.focus();
};
const selectYear = (yearEl) => {
  if (yearEl.disabled)
    return;
  const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(yearEl);
  const selectedYear = parseInt(yearEl.innerHTML, 10);
  let date = setYear(calendarDate, selectedYear);
  date = keepDateBetweenMinAndMax(date, minDate, maxDate);
  const newCalendar = renderCalendar(calendarEl, date);
  newCalendar.querySelector(CALENDAR_DATE_FOCUSED).focus();
};
const handleEscapeFromCalendar = (event) => {
  const { datePickerEl, externalInputEl } = getDatePickerContext(event.target);
  hideCalendar(datePickerEl);
  externalInputEl.focus();
  event.preventDefault();
};
const adjustCalendar = (adjustDateFn) => {
  return (event) => {
    const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(event.target);
    const date = adjustDateFn(calendarDate);
    const cappedDate = keepDateBetweenMinAndMax(date, minDate, maxDate);
    if (!isSameDay(calendarDate, cappedDate)) {
      const newCalendar = renderCalendar(calendarEl, cappedDate);
      newCalendar.querySelector(CALENDAR_DATE_FOCUSED).focus();
    }
    event.preventDefault();
  };
};
const handleUpFromDate = adjustCalendar((date) => subWeeks(date, 1));
const handleDownFromDate = adjustCalendar((date) => addWeeks(date, 1));
const handleLeftFromDate = adjustCalendar((date) => subDays(date, 1));
const handleRightFromDate = adjustCalendar((date) => addDays(date, 1));
const handleHomeFromDate = adjustCalendar((date) => startOfWeek(date));
const handleEndFromDate = adjustCalendar((date) => endOfWeek(date));
const handlePageDownFromDate = adjustCalendar((date) => addMonths(date, 1));
const handlePageUpFromDate = adjustCalendar((date) => subMonths(date, 1));
const handleShiftPageDownFromDate = adjustCalendar((date) => addYears(date, 1));
const handleShiftPageUpFromDate = adjustCalendar((date) => subYears(date, 1));
const adjustMonthSelectionScreen = (adjustMonthFn) => {
  return (event) => {
    const monthEl = event.target;
    const selectedMonth = parseInt(monthEl.dataset.value, 10);
    const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(monthEl);
    const currentDate = setMonth(calendarDate, selectedMonth);
    let adjustedMonth = adjustMonthFn(selectedMonth);
    adjustedMonth = Math.max(0, Math.min(11, adjustedMonth));
    const date = setMonth(calendarDate, adjustedMonth);
    const cappedDate = keepDateBetweenMinAndMax(date, minDate, maxDate);
    if (!isSameMonth(currentDate, cappedDate)) {
      const newCalendar = displayMonthSelection(calendarEl, cappedDate.getMonth());
      newCalendar.querySelector(CALENDAR_MONTH_FOCUSED).focus();
    }
    event.preventDefault();
  };
};
const handleUpFromMonth = adjustMonthSelectionScreen((month) => month - 1);
const handleDownFromMonth = adjustMonthSelectionScreen((month) => month + 1);
const handleLeftFromMonth = adjustMonthSelectionScreen((month) => month - 1);
const handleRightFromMonth = adjustMonthSelectionScreen((month) => month + 1);
const handleHomeFromMonth = adjustMonthSelectionScreen((month) => month - month % 3);
const handleEndFromMonth = adjustMonthSelectionScreen((month) => month + 2 - month % 3);
const handlePageDownFromMonth = adjustMonthSelectionScreen(() => 11);
const handlePageUpFromMonth = adjustMonthSelectionScreen(() => 0);
const adjustYearSelectionScreen = (adjustYearFn) => {
  return (event) => {
    const yearEl = event.target;
    const selectedYear = parseInt(yearEl.dataset.value, 10);
    const { calendarEl, calendarDate, minDate, maxDate } = getDatePickerContext(yearEl);
    const currentDate = setYear(calendarDate, selectedYear);
    let adjustedYear = adjustYearFn(selectedYear);
    adjustedYear = Math.max(0, adjustedYear);
    const date = setYear(calendarDate, adjustedYear);
    const cappedDate = keepDateBetweenMinAndMax(date, minDate, maxDate);
    if (!isSameYear(currentDate, cappedDate)) {
      const newCalendar = displayYearSelection(calendarEl, cappedDate.getFullYear());
      newCalendar.querySelector(CALENDAR_YEAR_FOCUSED).focus();
    }
    event.preventDefault();
  };
};
const handleUpFromYear = adjustYearSelectionScreen((year) => year - 3);
const handleDownFromYear = adjustYearSelectionScreen((year) => year + 3);
const handleLeftFromYear = adjustYearSelectionScreen((year) => year - 1);
const handleRightFromYear = adjustYearSelectionScreen((year) => year + 1);
const handleHomeFromYear = adjustYearSelectionScreen((year) => year - year % 3);
const handleEndFromYear = adjustYearSelectionScreen((year) => year + 2 - year % 3);
const handlePageUpFromYear = adjustYearSelectionScreen((year) => year - YEAR_CHUNK);
const handlePageDownFromYear = adjustYearSelectionScreen((year) => year + YEAR_CHUNK);
const tabHandler = (focusable) => {
  const getFocusableContext = (el) => {
    const { calendarEl } = getDatePickerContext(el);
    const focusableElements = select(focusable, calendarEl);
    const { activeElement } = el.closest(".leaf-c-date-picker").parentNode;
    const firstTabIndex = 0;
    const lastTabIndex = focusableElements.length - 1;
    const firstTabStop = focusableElements[firstTabIndex];
    const lastTabStop = focusableElements[lastTabIndex];
    const focusIndex = focusableElements.indexOf(activeElement);
    const isLastTab = focusIndex === lastTabIndex;
    const isFirstTab = focusIndex === firstTabIndex;
    const isNotFound = focusIndex === -1;
    return {
      focusableElements,
      isNotFound,
      firstTabStop,
      isFirstTab,
      lastTabStop,
      isLastTab
    };
  };
  return {
    tabAhead(event) {
      const { firstTabStop, isLastTab, isNotFound } = getFocusableContext(event.target);
      if (isLastTab || isNotFound) {
        event.preventDefault();
        firstTabStop.focus();
      }
    },
    tabBack(event) {
      const { lastTabStop, isFirstTab, isNotFound } = getFocusableContext(event.target);
      if (isFirstTab || isNotFound) {
        event.preventDefault();
        lastTabStop.focus();
      }
    }
  };
};
const datePickerTabEventHandler = tabHandler(DATE_PICKER_FOCUSABLE);
const monthPickerTabEventHandler = tabHandler(MONTH_PICKER_FOCUSABLE);
const yearPickerTabEventHandler = tabHandler(YEAR_PICKER_FOCUSABLE);
const datePickerEvents = {
  [CLICK]: {
    [DATE_PICKER_BUTTON]() {
      toggleCalendar(this);
    },
    [CALENDAR_DATE]() {
      selectDate(this);
    },
    [CALENDAR_MONTH]() {
      selectMonth(this);
    },
    [CALENDAR_YEAR]() {
      selectYear(this);
    },
    [CALENDAR_PREVIOUS_MONTH]() {
      displayPreviousMonth(this);
    },
    [CALENDAR_NEXT_MONTH]() {
      displayNextMonth(this);
    },
    [CALENDAR_PREVIOUS_YEAR]() {
      displayPreviousYear(this);
    },
    [CALENDAR_NEXT_YEAR]() {
      displayNextYear(this);
    },
    [CALENDAR_PREVIOUS_YEAR_CHUNK]() {
      displayPreviousYearChunk(this);
    },
    [CALENDAR_NEXT_YEAR_CHUNK]() {
      displayNextYearChunk(this);
    },
    [CALENDAR_MONTH_SELECTION]() {
      const newCalendar = displayMonthSelection(this);
      newCalendar.querySelector(CALENDAR_MONTH_FOCUSED).focus();
    },
    [CALENDAR_YEAR_SELECTION]() {
      const newCalendar = displayYearSelection(this);
      newCalendar.querySelector(CALENDAR_YEAR_FOCUSED).focus();
    }
  },
  keyup: {
    [DATE_PICKER_CALENDAR](event) {
      const keydown = this.dataset.keydownKeyCode;
      if (`${event.keyCode}` !== keydown) {
        event.preventDefault();
      }
    }
  },
  keydown: {
    [DATE_PICKER_EXTERNAL_INPUT](event) {
      if (event.keyCode === ENTER_KEYCODE)
        ;
    },
    [CALENDAR_DATE](event) {
      switch (event.key) {
        case "ArrowUp":
        case "Up":
          handleUpFromDate(event);
          break;
        case "ArrowDown":
        case "Down":
          handleDownFromDate(event);
          break;
        case "ArrowLeft":
        case "Left":
          handleLeftFromDate(event);
          break;
        case "ArrowRight":
        case "Right":
          handleRightFromDate(event);
          break;
        case "Home":
          handleHomeFromDate(event);
          break;
        case "End":
          handleEndFromDate(event);
          break;
        case "PageDown":
          handlePageDownFromDate(event);
          break;
        case "PageUp":
          handlePageUpFromDate(event);
          break;
        case "Shift+PageDown":
          handleShiftPageDownFromDate(event);
          break;
        case "Shift+PageUp":
          handleShiftPageUpFromDate(event);
          break;
      }
    },
    [CALENDAR_DATE_PICKER](event) {
      switch (event.key) {
        case "Tab":
          datePickerTabEventHandler.tabAhead(event);
          break;
        case "Shift+Tab":
          datePickerTabEventHandler.tabBack(event);
          break;
      }
    },
    [CALENDAR_MONTH](event) {
      switch (event.key) {
        case "ArrowUp":
        case "Up":
          handleUpFromMonth(event);
          break;
        case "ArrowDown":
        case "Down":
          handleDownFromMonth(event);
          break;
        case "ArrowLeft":
        case "Left":
          handleLeftFromMonth(event);
          break;
        case "ArrowRight":
        case "Right":
          handleRightFromMonth(event);
          break;
        case "Home":
          handleHomeFromMonth(event);
          break;
        case "End":
          handleEndFromMonth(event);
          break;
        case "PageDown":
          handlePageDownFromMonth(event);
          break;
        case "PageUp":
          handlePageUpFromMonth(event);
          break;
      }
    },
    [CALENDAR_MONTH_PICKER](event) {
      switch (event.key) {
        case "Tab":
          monthPickerTabEventHandler.tabAhead(event);
          break;
        case "Shift+Tab":
          monthPickerTabEventHandler.tabBack(event);
          break;
      }
    },
    [CALENDAR_YEAR](event) {
      switch (event.key) {
        case "ArrowUp":
        case "Up":
          handleUpFromYear(event);
          break;
        case "ArrowDown":
        case "Down":
          handleDownFromYear(event);
          break;
        case "ArrowLeft":
        case "Left":
          handleLeftFromYear(event);
          break;
        case "ArrowRight":
        case "Right":
          handleRightFromYear(event);
          break;
        case "Home":
          handleHomeFromYear(event);
          break;
        case "End":
          handleEndFromYear(event);
          break;
        case "PageDown":
          handlePageDownFromYear(event);
          break;
        case "PageUp":
          handlePageUpFromYear(event);
          break;
      }
    },
    [CALENDAR_YEAR_PICKER](event) {
      switch (event.key) {
        case "Tab":
          yearPickerTabEventHandler.tabAhead(event);
          break;
        case "Shift+Tab":
          yearPickerTabEventHandler.tabBack(event);
          break;
      }
    },
    [DATE_PICKER_CALENDAR](event) {
      this.dataset.keydownKeyCode = event.keyCode;
    },
    [DATE_PICKER](event) {
      if (event.key === "Escape") {
        handleEscapeFromCalendar(event);
      }
    }
  },
  focusout: {
    [DATE_PICKER](event) {
      if (!this.contains(event.relatedTarget)) {
        hideCalendar(this);
      }
    }
  },
  input: {
    [DATE_PICKER_EXTERNAL_INPUT]() {
      reconcileInputValues(this);
      updateCalendarIfVisible(this);
    }
  }
};
const datePickerCalendar = datepickerBehavior(datePickerEvents, {
  init(root) {
    select(DATE_PICKER, root).forEach((datePickerEl) => {
      enhanceDatePicker(datePickerEl);
    });
  },
  //
  setDateFormat,
  //
  setMonthLabels,
  setShortMonthLabels,
  setDayOfWeekLabels,
  setShortDayOfWeekLabels,
  setInstructions,
  setCalendarNavigations,
  setSelections,
  //
  getDatePickerContext,
  disable,
  enable,
  isDateInputInvalid,
  setCalendarValue,
  renderCalendar,
  updateCalendarIfVisible
});
const styles = '@charset "UTF-8";\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n/* ------------------------------------*\\\n    #TYPOGRAPHY PLACEHOLDERS\n\\*------------------------------------ */\n.usa-date-picker__calendar__previous-year,\n.usa-date-picker__calendar__previous-month,\n.usa-date-picker__calendar__next-year,\n.usa-date-picker__calendar__next-month,\n.usa-date-picker__calendar__year-selection,\n.usa-date-picker__calendar__month-selection, .usa-date-picker__calendar__previous-year-chunk,\n.usa-date-picker__calendar__next-year-chunk, .usa-date-picker__calendar__year,\n.usa-date-picker__calendar__month, .usa-date-picker__calendar__day-of-week, .usa-date-picker__calendar__date {\n  font-family: var(--leaf-typography-label-small-font-family);\n  font-size: var(--leaf-typography-label-small-font-size);\n  font-weight: var(--leaf-typography-label-small-font-weight);\n  line-height: var(--leaf-typography-label-small-line-height);\n  -webkit-text-decoration: var(--leaf-typography-label-small-text-decoration);\n          text-decoration: var(--leaf-typography-label-small-text-decoration);\n  text-transform: var(--leaf-typography-label-small-text-transform);\n}\n\n/*\n  Hiding class, making content visible only to screen readers but not visually ("sr" meaning "screen-reader")\n  Is the hidden content read by a screen reader?	- Yes\n  Will the hidden element affect the document layout? - No\n  Will the hidden element’s box model be rendered? - No\n  Does the element detect clicks or focus? - Yes\n  https://css-tricks.com/comparing-various-ways-to-hide-things-in-css/#method-5-the-visually-hidden-class\n*/\n.usa-sr-only {\n  clip: rect(0 0 0 0);\n  -webkit-clip-path: inset(50%);\n          clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n:host {\n  display: block;\n}\n:host leaf-input {\n  width: 100%;\n}\n:host leaf-button {\n  position: absolute;\n  right: var(--leaf-spacing-24);\n  transform: translateY(calc(var(--leaf-spacing-16) - var(--leaf-spacing-2)));\n}\n\n.usa-date-picker__calendar__date, .usa-date-picker__calendar__day-of-week, .usa-date-picker__calendar__year,\n.usa-date-picker__calendar__month, .usa-date-picker__calendar__previous-year-chunk,\n.usa-date-picker__calendar__next-year-chunk, .usa-date-picker__calendar__previous-year,\n.usa-date-picker__calendar__previous-month,\n.usa-date-picker__calendar__next-year,\n.usa-date-picker__calendar__next-month,\n.usa-date-picker__calendar__year-selection,\n.usa-date-picker__calendar__month-selection {\n  background-color: var(--datepicker-calendar-primary);\n  border: 0;\n  color: var(--leaf-color-button-tertiary-content);\n  height: var(--datepicker-size);\n  line-height: normal;\n  min-width: var(--datepicker-size);\n  padding: var(--leaf-spacing-8);\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.usa-date-picker__calendar__date:not([disabled]), .usa-date-picker__calendar__day-of-week:not([disabled]), .usa-date-picker__calendar__year:not([disabled]),\n.usa-date-picker__calendar__month:not([disabled]), .usa-date-picker__calendar__previous-year-chunk:not([disabled]),\n.usa-date-picker__calendar__next-year-chunk:not([disabled]), .usa-date-picker__calendar__previous-year:not([disabled]),\n.usa-date-picker__calendar__previous-month:not([disabled]),\n.usa-date-picker__calendar__next-year:not([disabled]),\n.usa-date-picker__calendar__next-month:not([disabled]),\n.usa-date-picker__calendar__year-selection:not([disabled]),\n.usa-date-picker__calendar__month-selection:not([disabled]) {\n  cursor: pointer;\n}\n\n.usa-date-picker__calendar__date, .usa-date-picker__calendar__year,\n.usa-date-picker__calendar__month, .usa-date-picker__calendar__previous-year-chunk,\n.usa-date-picker__calendar__next-year-chunk {\n  border-radius: var(--datepicker-border-radius);\n  margin: var(--leaf-spacing-4);\n}\n.usa-date-picker__calendar__date:not([disabled]):hover, .usa-date-picker__calendar__year:not([disabled]):hover,\n.usa-date-picker__calendar__month:not([disabled]):hover, .usa-date-picker__calendar__previous-year-chunk:not([disabled]):hover,\n.usa-date-picker__calendar__next-year-chunk:not([disabled]):hover, .usa-date-picker__calendar__date:not([disabled]):focus, .usa-date-picker__calendar__year:not([disabled]):focus,\n.usa-date-picker__calendar__month:not([disabled]):focus, .usa-date-picker__calendar__previous-year-chunk:not([disabled]):focus,\n.usa-date-picker__calendar__next-year-chunk:not([disabled]):focus {\n  background-color: var(--leaf-color-button-primary-bg-hover);\n  border-color: var(--leaf-color-button-primary-border-hover);\n  color: var(--leaf-color-button-primary-content-hover);\n}\n.usa-date-picker__calendar__date:not([disabled]):focus-visible, .usa-date-picker__calendar__year:not([disabled]):focus-visible,\n.usa-date-picker__calendar__month:not([disabled]):focus-visible, .usa-date-picker__calendar__previous-year-chunk:not([disabled]):focus-visible,\n.usa-date-picker__calendar__next-year-chunk:not([disabled]):focus-visible, .usa-date-picker__calendar__date:not([disabled]):focus, .usa-date-picker__calendar__year:not([disabled]):focus,\n.usa-date-picker__calendar__month:not([disabled]):focus, .usa-date-picker__calendar__previous-year-chunk:not([disabled]):focus,\n.usa-date-picker__calendar__next-year-chunk:not([disabled]):focus {\n  background-color: var(--leaf-color-button-primary-bg);\n  outline: var(--leaf-border-width-focus) solid var(--leaf-color-button-primary-outline);\n  outline-offset: var(--leaf-border-width-focus);\n}\n.usa-date-picker__calendar__date:not([disabled]):active:focus, .usa-date-picker__calendar__year:not([disabled]):active:focus,\n.usa-date-picker__calendar__month:not([disabled]):active:focus, .usa-date-picker__calendar__previous-year-chunk:not([disabled]):active:focus,\n.usa-date-picker__calendar__next-year-chunk:not([disabled]):active:focus {\n  background-color: var(--leaf-color-button-primary-bg-active);\n  border: var(--leaf-border-width-default) solid transparent;\n  color: var(--leaf-color-button-primary-content-active);\n  outline: none;\n}\n.usa-date-picker__calendar__date:not([disabled])[disabled], .usa-date-picker__calendar__year:not([disabled])[disabled],\n.usa-date-picker__calendar__month:not([disabled])[disabled], .usa-date-picker__calendar__previous-year-chunk:not([disabled])[disabled],\n.usa-date-picker__calendar__next-year-chunk:not([disabled])[disabled] {\n  background-color: var(--leaf-color-button-primary-bg-disabled);\n  border-color: var(--leaf-color-button-primary-border-disabled);\n  color: var(--leaf-color-button-primary-content-disabled);\n}\n.usa-date-picker__calendar__date:not([disabled])[disabled]:hover, .usa-date-picker__calendar__year:not([disabled])[disabled]:hover,\n.usa-date-picker__calendar__month:not([disabled])[disabled]:hover, .usa-date-picker__calendar__previous-year-chunk:not([disabled])[disabled]:hover,\n.usa-date-picker__calendar__next-year-chunk:not([disabled])[disabled]:hover, .usa-date-picker__calendar__date:not([disabled])[disabled]:focus, .usa-date-picker__calendar__year:not([disabled])[disabled]:focus,\n.usa-date-picker__calendar__month:not([disabled])[disabled]:focus, .usa-date-picker__calendar__previous-year-chunk:not([disabled])[disabled]:focus,\n.usa-date-picker__calendar__next-year-chunk:not([disabled])[disabled]:focus, .usa-date-picker__calendar__date:not([disabled])[disabled]:active, .usa-date-picker__calendar__year:not([disabled])[disabled]:active,\n.usa-date-picker__calendar__month:not([disabled])[disabled]:active, .usa-date-picker__calendar__previous-year-chunk:not([disabled])[disabled]:active,\n.usa-date-picker__calendar__next-year-chunk:not([disabled])[disabled]:active {\n  background-color: var(--leaf-color-button-primary-bg-disabled);\n  border-color: var(--leaf-color-button-primary-border-disabled);\n  color: var(--leaf-color-button-primary-content-disabled);\n}\n\n:host {\n  --datepicker-color: var(--leaf-color-content-knockout);\n  --datepicker-calendar-primary: var(--leaf-color-bg-default);\n  --datepicker-border-radius-pill: var(--leaf-spacing-32);\n  --datepicker-border-radius-square: var(--leaf-border-width-large);\n  --datepicker-max-width: calc(320px - var(--leaf-spacing-16));\n  --datepicker-line-height: calc(var(--leaf-spacing-16) / var(--leaf-font-size-1));\n  --datepicker-size: var(--leaf-spacing-32);\n}\n\n.usa-date-picker__wrapper {\n  display: none;\n  max-width: 100%;\n  position: relative;\n}\n.usa-date-picker__wrapper:focus {\n  outline: 0;\n}\n\n.usa-date-picker--initialized .usa-date-picker__wrapper {\n  display: flex;\n}\n\n.usa-date-picker--active .usa-date-picker__calendar {\n  z-index: var(--leafdcws-z-index-100);\n}\n\n.usa-date-picker__internal-input {\n  display: none;\n}\n\n.usa-date-picker__calendar {\n  background-color: var(--datepicker-calendar-primary);\n  border: var(--leaf-border-width-default) solid var(--leaf-color-border-strong);\n  border-radius: var(--leaf-border-radius-default);\n  box-shadow: var(--leaf-shadow-default);\n  left: 50%;\n  padding: calc(var(--leaf-spacing-8) - var(--leaf-border-width-default));\n  position: absolute;\n  transform: translate(-50%, 0);\n  width: var(--datepicker-max-width);\n  z-index: var(--leafdcws-z-index-200);\n}\n@media (min-width: 23.4375rem) {\n  .usa-date-picker__calendar {\n    left: unset;\n    right: 0;\n    transform: unset;\n  }\n}\n.usa-date-picker__calendar:focus {\n  outline: none;\n}\n\n.usa-date-picker__calendar__month-picker:focus,\n.usa-date-picker__calendar__year-picker:focus,\n.usa-date-picker__calendar__date-picker:focus {\n  outline: none;\n}\n\n.usa-date-picker__calendar__table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed;\n  text-align: center;\n  width: 100%;\n}\n.usa-date-picker__calendar__table th {\n  font-weight: normal;\n}\n.usa-date-picker__calendar__table td {\n  padding: 0;\n}\n\n.usa-date-picker__calendar__row {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  text-align: center;\n  width: 100%;\n}\n\n.usa-date-picker__calendar__cell {\n  background-color: var(--datepicker-calendar-primary);\n  flex: 1;\n}\n\n.usa-date-picker__calendar__cell--center-items {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.usa-date-picker__calendar__date--next-month:not([disabled]),\n.usa-date-picker__calendar__date--previous-month:not([disabled]) {\n  color: var(--leaf-color-content-subtle);\n}\n\n.usa-date-picker__calendar__previous-year,\n.usa-date-picker__calendar__previous-month,\n.usa-date-picker__calendar__next-year,\n.usa-date-picker__calendar__next-month,\n.usa-date-picker__calendar__year-selection,\n.usa-date-picker__calendar__month-selection {\n  --datepicker-border-radius: var(--datepicker-border-radius-pill);\n  align-items: center;\n  border-radius: var(--datepicker-border-radius);\n  display: flex;\n  justify-content: center;\n  margin: var(--leaf-spacing-4);\n}\n.usa-date-picker__calendar__previous-year:not([disabled]):hover, .usa-date-picker__calendar__previous-year:not([disabled]):focus,\n.usa-date-picker__calendar__previous-month:not([disabled]):hover,\n.usa-date-picker__calendar__previous-month:not([disabled]):focus,\n.usa-date-picker__calendar__next-year:not([disabled]):hover,\n.usa-date-picker__calendar__next-year:not([disabled]):focus,\n.usa-date-picker__calendar__next-month:not([disabled]):hover,\n.usa-date-picker__calendar__next-month:not([disabled]):focus,\n.usa-date-picker__calendar__year-selection:not([disabled]):hover,\n.usa-date-picker__calendar__year-selection:not([disabled]):focus,\n.usa-date-picker__calendar__month-selection:not([disabled]):hover,\n.usa-date-picker__calendar__month-selection:not([disabled]):focus {\n  outline: var(--leaf-border-width-focus) solid var(--leaf-color-button-tertiary-border-active);\n}\n.usa-date-picker__calendar__previous-year:not([disabled]):focus-visible, .usa-date-picker__calendar__previous-year:not([disabled]):focus,\n.usa-date-picker__calendar__previous-month:not([disabled]):focus-visible,\n.usa-date-picker__calendar__previous-month:not([disabled]):focus,\n.usa-date-picker__calendar__next-year:not([disabled]):focus-visible,\n.usa-date-picker__calendar__next-year:not([disabled]):focus,\n.usa-date-picker__calendar__next-month:not([disabled]):focus-visible,\n.usa-date-picker__calendar__next-month:not([disabled]):focus,\n.usa-date-picker__calendar__year-selection:not([disabled]):focus-visible,\n.usa-date-picker__calendar__year-selection:not([disabled]):focus,\n.usa-date-picker__calendar__month-selection:not([disabled]):focus-visible,\n.usa-date-picker__calendar__month-selection:not([disabled]):focus {\n  outline: var(--leaf-border-width-focus) solid var(--leaf-color-button-primary-outline);\n  outline-offset: var(--leaf-border-width-focus);\n}\n.usa-date-picker__calendar__previous-year:not([disabled]):active,\n.usa-date-picker__calendar__previous-month:not([disabled]):active,\n.usa-date-picker__calendar__next-year:not([disabled]):active,\n.usa-date-picker__calendar__next-month:not([disabled]):active,\n.usa-date-picker__calendar__year-selection:not([disabled]):active,\n.usa-date-picker__calendar__month-selection:not([disabled]):active {\n  background-color: var(--leaf-color-button-tertiary-bg-active);\n  outline-color: var(--leaf-color-button-tertiary-border-active);\n  color: var(--leaf-color-button-tertiary-content);\n}\n.usa-date-picker__calendar__previous-year:not([disabled])[disabled],\n.usa-date-picker__calendar__previous-month:not([disabled])[disabled],\n.usa-date-picker__calendar__next-year:not([disabled])[disabled],\n.usa-date-picker__calendar__next-month:not([disabled])[disabled],\n.usa-date-picker__calendar__year-selection:not([disabled])[disabled],\n.usa-date-picker__calendar__month-selection:not([disabled])[disabled] {\n  background-color: var(--leaf-color-button-primary-bg-disabled);\n  outline-color: var(--leaf-color-button-primary-border-disabled);\n  color: var(--leaf-color-button-primary-content-disabled);\n}\n.usa-date-picker__calendar__previous-year:not([disabled])[disabled]:hover, .usa-date-picker__calendar__previous-year:not([disabled])[disabled]:focus, .usa-date-picker__calendar__previous-year:not([disabled])[disabled]:active,\n.usa-date-picker__calendar__previous-month:not([disabled])[disabled]:hover,\n.usa-date-picker__calendar__previous-month:not([disabled])[disabled]:focus,\n.usa-date-picker__calendar__previous-month:not([disabled])[disabled]:active,\n.usa-date-picker__calendar__next-year:not([disabled])[disabled]:hover,\n.usa-date-picker__calendar__next-year:not([disabled])[disabled]:focus,\n.usa-date-picker__calendar__next-year:not([disabled])[disabled]:active,\n.usa-date-picker__calendar__next-month:not([disabled])[disabled]:hover,\n.usa-date-picker__calendar__next-month:not([disabled])[disabled]:focus,\n.usa-date-picker__calendar__next-month:not([disabled])[disabled]:active,\n.usa-date-picker__calendar__year-selection:not([disabled])[disabled]:hover,\n.usa-date-picker__calendar__year-selection:not([disabled])[disabled]:focus,\n.usa-date-picker__calendar__year-selection:not([disabled])[disabled]:active,\n.usa-date-picker__calendar__month-selection:not([disabled])[disabled]:hover,\n.usa-date-picker__calendar__month-selection:not([disabled])[disabled]:focus,\n.usa-date-picker__calendar__month-selection:not([disabled])[disabled]:active {\n  background-color: var(--leaf-color-button-primary-bg-disabled);\n  outline-color: var(--leaf-color-button-primary-border-disabled);\n  color: var(--leaf-color-button-primary-content-disabled);\n}\n\n.usa-date-picker__calendar__previous-year,\n.usa-date-picker__calendar__previous-month,\n.usa-date-picker__calendar__next-year,\n.usa-date-picker__calendar__next-month {\n  height: var(--leaf-spacing-32);\n  padding: 0;\n  width: var(--leaf-spacing-32);\n}\n\n.usa-date-picker__calendar__previous-year-chunk,\n.usa-date-picker__calendar__next-year-chunk {\n  --datepicker-border-radius: var(--datepicker-border-radius-pill);\n  height: auto;\n}\n\n.usa-date-picker__calendar__month-label {\n  align-items: center;\n  display: flex;\n  flex: 2;\n  flex-direction: row;\n  text-align: center;\n}\n\n.usa-date-picker__calendar__year,\n.usa-date-picker__calendar__month {\n  --datepicker-border-radius: var(--datepicker-border-radius-pill);\n  border: var(--leaf-border-width-default) solid transparent;\n  height: auto;\n}\n.usa-date-picker__calendar__year--selected:not([disabled]),\n.usa-date-picker__calendar__month--selected:not([disabled]) {\n  background-color: var(--leaf-color-button-primary-bg);\n  color: var(--datepicker-color);\n}\n\n.usa-date-picker__calendar__day-of-week {\n  color: var(--leaf-color-content-default);\n  pointer-events: none;\n}\n\n.usa-date-picker__calendar__date {\n  --datepicker-border-radius: 50%;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  line-height: normal;\n  width: var(--leaf-spacing-32);\n}\n.usa-date-picker__calendar__date[disabled] {\n  color: var(--leaf-color-content-disabled);\n}\n.usa-date-picker__calendar__date--selected:not([disabled]) {\n  background-color: var(--leaf-color-button-tertiary-content);\n  color: var(--datepicker-color);\n}\n.usa-date-picker__calendar__date--focused:not([disabled]) {\n  background-color: var(--leaf-color-button-primary-bg);\n  color: var(--datepicker-color);\n}\n\n.usa-date-picker__calendar__date--today:not([disabled]) {\n  border: var(--leaf-border-width-default) solid var(--leaf-color-border-strong);\n}\n\n.usa-date-picker__calendar__date--today.usa-date-picker__calendar__date--selected:not([disabled]) {\n  border: unset;\n  border-radius: var(--datepicker-border-radius-square);\n}';
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let counter = 0;
let hasLoaded = false;
const _LeafDatePicker = class _LeafDatePicker extends LeafElement {
  constructor() {
    super(...arguments);
    this.i18nController = new I18nController(this);
    this.autofocus = false;
    this.disabled = false;
    this.format = "usa";
    this.hidden = false;
    this._id = ++counter;
    this._name = "datepicker";
    this.required = false;
    this._value = "";
  }
  /**
   * The form that this input will be attached to.
   */
  get _internalsForm() {
    return this.closest("form");
  }
  /**
   * The hidden input which reports to the form.
   */
  get _hiddenInput() {
    var _a;
    return (_a = this._internalsForm) == null ? void 0 : _a.querySelector(`leaf-input[name="${this.name}"][id="${this._name}-${this._id}-hidden"]`);
  }
  get datePattern() {
    return this.pattern ? this.pattern : this.format === "universal" ? "^[0-9]{4}-(1[0-2]|0[1-9])-(3[01]|[12][0-9]|0[1-9])$" : "^(1[0-2]|0[1-9])/(3[01]|[12][0-9]|0[1-9])/[0-9]{4}$";
  }
  get value() {
    const { _externalInput } = this;
    return _externalInput ? _externalInput.value : this._value;
  }
  set value(value) {
    const { _externalInput } = this;
    const oldValue = this._value;
    this._value = value;
    this.requestUpdate("value", oldValue);
    if (_externalInput) {
      _externalInput.value = value;
    }
  }
  async updated(changedProperties) {
    var _a;
    if (hasLoaded) {
      const allEls = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll("leaf-input, input, leaf-button");
      for (const [key, _value] of changedProperties) {
        const property2 = String(key);
        if (typeof this[property2] !== "undefined") {
          if (this[property2]) {
            allEls == null ? void 0 : allEls.forEach((el) => el.setAttribute(property2, String(this[property2])));
          } else {
            allEls == null ? void 0 : allEls.forEach((el) => el.removeAttribute(property2));
          }
        }
      }
      if (!changedProperties.has("value") && !changedProperties.has("_value")) {
        await this.setValueForm();
        this.updateInputValidation();
      }
    }
  }
  async firstUpdated(changedProperties) {
    var _a, _b, _c, _d;
    super.firstUpdated(changedProperties);
    await this.updateComplete;
    await datePickerCalendar.on(this._inputWrapper);
    (_b = (_a = this._datepickerButton.shadowRoot) == null ? void 0 : _a.querySelector("button")) == null ? void 0 : _b.setAttribute("aria-haspopup", "true");
    (_d = (_c = this._datepickerButton.shadowRoot) == null ? void 0 : _c.querySelector("button")) == null ? void 0 : _d.setAttribute("aria-label", `${this.i18nController.term("instructions_six")}`);
    if (this.initialValue) {
      this.value = this.initialValue;
      await this.setValueForm();
      this.updateInputValidation();
    } else {
      this.setValueForm();
    }
    ["input", "change"].forEach(
      (eventName) => this._externalInput.addEventListener(eventName, async (event) => {
        if (eventName === "input") {
          this.value = this._externalInput.input.value;
          await this.setValueForm();
          this.updateInputValidation();
        }
        if (eventName === "change" && this._externalInput.value && event.target === this._externalInput) {
          this._externalInput.input.value = this._externalInput.value;
          await this.setValueForm();
          this.updateInputValidation();
        }
      })
    );
    this._internalInput.addEventListener("change", () => this.value = this._internalInput.value || "");
    window.addEventListener("leaf-form-submit-request", () => this.updateInputValidation(true));
    hasLoaded = true;
  }
  async disconnectedCallback() {
    super.disconnectedCallback();
    await datePickerCalendar.off(this._inputWrapper);
  }
  async setValueForm() {
    if (this._internalsForm) {
      if (this._hiddenInput) {
        this._hiddenInput.remove();
      }
      if (this.name) {
        const newInput = document.createElement("leaf-input");
        newInput.name = this.name;
        newInput.id = `${this._name}-${this._id}-hidden`;
        newInput.value = this.value ? this.value : "";
        newInput.required = this.required;
        newInput.disabled = this.disabled;
        newInput.pattern = this.datePattern;
        newInput.style.display = "none";
        this._internalsForm.appendChild(newInput);
      }
    }
  }
  updateInputValidation(submitRequest = false) {
    if (this._hiddenInput && this._internalsForm) {
      this._internalInput.value = this._externalInput.input.value;
      this._externalInput.internals.setValidity(
        this._hiddenInput.internals.validity,
        this._hiddenInput.internals.validationMessage
      );
      this._externalInput.validation.validate(this.value ? this.value : void 0);
      if (submitRequest) {
        this._externalInput.internals.checkValidity();
      }
      if (this._externalInput.valid && this.value) {
        datePickerCalendar.setCalendarValue(this._calendarWrapper, formatDate$1(this.value), false);
      }
    }
  }
  render() {
    const { autofocus, disabled, format, hint, label, name, placeholder, rangeDate, required, value } = this;
    const mask = this.mask && this.mask.length > 0 ? this.format === "universal" ? "0000-00-00" : "00/00/0000" : void 0;
    let { maxDate, minDate } = this;
    const idName = `${this._name}-${this._id}`;
    datePickerCalendar.setDateFormat(this.format === "universal" ? "YYYY-MM-DD" : "MM/DD/YYYY");
    datePickerCalendar.setMonthLabels([
      `${this.i18nController.term("january")}`,
      `${this.i18nController.term("february")}`,
      `${this.i18nController.term("march")}`,
      `${this.i18nController.term("april")}`,
      `${this.i18nController.term("may")}`,
      `${this.i18nController.term("june")}`,
      `${this.i18nController.term("july")}`,
      `${this.i18nController.term("august")}`,
      `${this.i18nController.term("september")}`,
      `${this.i18nController.term("october")}`,
      `${this.i18nController.term("november")}`,
      `${this.i18nController.term("december")}`
    ]);
    datePickerCalendar.setShortMonthLabels([
      `${this.i18nController.term("january_short")}`,
      `${this.i18nController.term("february_short")}`,
      `${this.i18nController.term("march_short")}`,
      `${this.i18nController.term("april_short")}`,
      `${this.i18nController.term("may_short")}`,
      `${this.i18nController.term("june_short")}`,
      `${this.i18nController.term("july_short")}`,
      `${this.i18nController.term("august_short")}`,
      `${this.i18nController.term("september_short")}`,
      `${this.i18nController.term("october_short")}`,
      `${this.i18nController.term("november_short")}`,
      `${this.i18nController.term("december_short")}`
    ]);
    datePickerCalendar.setDayOfWeekLabels([
      `${this.i18nController.term("sunday")}`,
      `${this.i18nController.term("monday")}`,
      `${this.i18nController.term("tuesday")}`,
      `${this.i18nController.term("wednesday")}`,
      `${this.i18nController.term("thursday")}`,
      `${this.i18nController.term("friday")}`,
      `${this.i18nController.term("saturday")}`
    ]);
    datePickerCalendar.setShortDayOfWeekLabels([
      `${this.i18nController.term("sunday_short")}`,
      `${this.i18nController.term("monday_short")}`,
      `${this.i18nController.term("tuesday_short")}`,
      `${this.i18nController.term("wednesday_short")}`,
      `${this.i18nController.term("thursday_short")}`,
      `${this.i18nController.term("friday_short")}`,
      `${this.i18nController.term("saturday_short")}`
    ]);
    datePickerCalendar.setInstructions([
      `${this.i18nController.term("instructions_one")}`,
      `${this.i18nController.term("instructions_two")}`,
      `${this.i18nController.term("instructions_three")}`,
      `${this.i18nController.term("instructions_four")}`,
      `${this.i18nController.term("instructions_five")}`
    ]);
    datePickerCalendar.setCalendarNavigations([
      `${this.i18nController.term("navigate_back_year")}`,
      `${this.i18nController.term("navigate_back_month")}`,
      `${this.i18nController.term("click_select_month")}`,
      `${this.i18nController.term("click_select_year")}`,
      `${this.i18nController.term("navigate_forward_month")}`,
      `${this.i18nController.term("navigate_forward_year")}`,
      `${this.i18nController.term("selected_date")}`
    ]);
    datePickerCalendar.setSelections([
      `${this.i18nController.term("back")}`,
      `${this.i18nController.term("forward")}`,
      `${this.i18nController.term("years")}`,
      `${this.i18nController.term("showing_years")}`,
      `${this.i18nController.term("select_year")}`,
      `${this.i18nController.term("select_month")}`,
      `${this.i18nController.term("to")}`
    ]);
    maxDate = maxDate ? formatDate$1(maxDate) : "";
    minDate = minDate ? formatDate$1(minDate) : "";
    return html`<div class="leaf-c-date-picker">
      <leaf-label for="${idName}">${label}</leaf-label>
      <div
        class="usa-date-picker"
        data-default-val
        ue="${value}"
        data-max-date="${ifDefined(maxDate)}"
        data-min-date="${ifDefined(minDate)}"
        data-range-date="${rangeDate}"
      >
        <leaf-input
          class="usa-input"
          ?autofocus=${autofocus}
          ?disabled=${disabled ? true : disabled}
          id="${idName}"
          name="${ifDefined(name)}"
          placeholder="${ifDefined(placeholder)}"
          ?required=${required}
          type="tel"
          .value="${disabled ? "" : value}"
          pattern="${this.datePattern}"
          max-date=${ifDefined(maxDate)}
          min-date=${ifDefined(minDate)}
          format="${format}"
          mask="${ifDefined(mask)}"
        >
          ${hint ? html` <span slot="note">${hint}</span>` : html`${nothing}`}
        </leaf-input>
      </div>
    </div>`;
  }
};
_LeafDatePicker.styles = unsafeCSS(styles);
let LeafDatePicker = _LeafDatePicker;
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "autocomplete", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafDatePicker.prototype, "autofocus", 2);
__decorateClass([
  query(".usa-date-picker__button")
], LeafDatePicker.prototype, "_datepickerButton", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafDatePicker.prototype, "disabled", 2);
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "format", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafDatePicker.prototype, "hidden", 2);
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "hint", 2);
__decorateClass([
  query("leaf-input:not(.usa-date-picker__internal-input)")
], LeafDatePicker.prototype, "_externalInput", 2);
__decorateClass([
  query("leaf-input:not(.usa-date-picker__external-input)")
], LeafDatePicker.prototype, "_internalInput", 2);
__decorateClass([
  query(".leaf-c-date-picker")
], LeafDatePicker.prototype, "_inputWrapper", 2);
__decorateClass([
  query(".usa-date-picker")
], LeafDatePicker.prototype, "_calendarWrapper", 2);
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "label", 2);
__decorateClass([
  property({ reflect: true, attribute: "max-date" })
], LeafDatePicker.prototype, "maxDate", 2);
__decorateClass([
  property({ reflect: true, attribute: "min-date" })
], LeafDatePicker.prototype, "minDate", 2);
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "name", 2);
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "pattern", 2);
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "placeholder", 2);
__decorateClass([
  property({ reflect: true, attribute: "range-date" })
], LeafDatePicker.prototype, "rangeDate", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafDatePicker.prototype, "required", 2);
__decorateClass([
  state()
], LeafDatePicker.prototype, "_value", 2);
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "value", 1);
__decorateClass([
  property({ reflect: true, attribute: "data-initial-value" })
], LeafDatePicker.prototype, "initialValue", 2);
__decorateClass([
  property({ reflect: true })
], LeafDatePicker.prototype, "mask", 2);
export {
  LeafDatePicker
};
//# sourceMappingURL=date-picker.component.js.map
